export enum EnumInvoiceGenerationInvokeType{
    Daily='Daily',
    Weekly='Weekly',
    Biweekly='Biweekly',
    Monthly='Monthly',
}

export const generateDropdownListForEnumInvoiceGenerationInvokeType = (): { label: string; value: EnumInvoiceGenerationInvokeType }[] => [
  { label: "Daily", value:  EnumInvoiceGenerationInvokeType.Daily },
  { label: "Weekly", value: EnumInvoiceGenerationInvokeType.Weekly },
  { label: "Biweekly", value: EnumInvoiceGenerationInvokeType.Biweekly },
  { label: "Monthly", value: EnumInvoiceGenerationInvokeType.Monthly },
];

